<div class="menu" [ngClass]="menuState">
  <nav class="nav flex-column" (click)="toggleMenu()">
    <ng-content></ng-content>
    <p class="version">Version - {{appVersion}}</p>
  </nav>
</div>
